App.filter('defaultLinkStep', function () {
    return function (link) {
        link = link || '';
        if (!link) {
            link = 'root.dashboard';
        }
        return link;
    };
})